import { ListSource, useAutocompleteSource, useFetch } from '@eas/common-web';
import { WorkOrderTypeAutocomplete } from '@models';
import { EvidenceApiUrl } from '@enums';

export function useWorkOrderTypes() {
  return useAutocompleteSource<WorkOrderTypeAutocomplete>({
    url: `${EvidenceApiUrl.WORK_ORDER_TYPES}/autocomplete`,
  });
}

export function useWorkOrderTypesList() {
  return useFetch<ListSource<WorkOrderTypeAutocomplete>>(
    `${EvidenceApiUrl.WORK_ORDER_TYPES}/list`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        size: -1,
        sort: [
          {
            field: 'name',
            order: 'ASC',
            type: 'FIELD',
            missing: 'LAST',
          },
        ],
      }),
    }
  );
}
